export const ReportFilterTypes = [
  {name: "غیرمجاز (ILLEGAL)", value: "ILLEGAL"},
  {name: "هرزنامه (SPAM)", value: "SPAM"},
];

export const ReportFilterStatus = [
  {name: "گزارش کاربر (USER_REPORT)", value: "USER_REPORT"},
  {name: "گزارش مکالمه (CONVERSATION_REPORT)", value: "CONVERSATION_REPORT"},
  {name: "گزارش پیام (MESSAGE_REPORT)", value: "MESSAGE_REPORT"},
];